// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"errorPage_root__vTaFf","errorImg":"errorPage_errorImg__11B+C"};